export const DEFAULT_SUBJECT_ANALYTICS_MARKS_TALLY = {
  attemptedMarks: 0,
  inaccuracyMarks: 0,
  missedMarks: 0,
  sillyMarks: 0,
};

const analyticsAttributes = [
  'analytics',
  'calculationAnalytics',
  'extendedResponseAnalytics',
  'graphingAnalytics',
  'multipleChoiceAnalytics',
  'proofAnalytics',
  'shortAnswerAnalytics',
] as const;

const getAttributes = ['student', 'subject', ...analyticsAttributes] as const;

export const StudentSubjectAnalyticsAttributes = {
  Get: getAttributes,
  Analytics: analyticsAttributes,
};
